var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loading",class:{
    'size-default': _vm.size === 'default',
    'size-big': _vm.size === 'big'
  }},[(_vm.loading)?_c('LoadingSVG',{style:({ top: _vm.pos })}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }